module.exports = __webpack_public_path__ + "img/logo_zzzland.c36d0d47.png";